var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"wrapper-tooltip",class:[_vm.upArrow ? '--up-arrow' : '--down-arrow'],style:(_vm.styleTooltip)},[_vm._v(" "+_vm._s(_vm._text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }